export default "__VITE_ASSET__BqNvMDsz__"